(function($){
    'use strict';

    /* add smooth scrool to all <a href="#link"/> anchors. The codes could be moved to global.js in the ..footer to enable this feature side-wide.
new SmoothScroll('a[href^="#"]', {
  topOnEmptyHash: false,
  updateURL: false
});*/

	if ($('.long-document').length > 0) {
    //set button
    var btnLeft = ($(window).width() - $('.section__inner').width()) / 2 + 280;
    $('#btn-show-hde-toc').css('left', btnLeft);
    $('#btn-show-hde-toc').css('display', 'block');
    /* Generate table of content html*/
    var tag, previousTag, title, idStr;
    var htmlStr = '';
  
    $('.section__column h2, .section__column h3, .section__column h4').each(function (index) {
      tag = $(this).prop('tagName');
      title = $(this).text();
      idStr = 'target'+index;
  
      $(this).attr('id', idStr);
  
      if (tag === 'H2') {
        if (previousTag === 'H2') {
          htmlStr = htmlStr + '</li>';
        } else if (previousTag === 'H3') {
          htmlStr = htmlStr + '</li></ul>';
        } else if (previousTag === 'H4') {
          htmlStr = htmlStr + '</li></ul></li></ul>';
        }
        htmlStr = htmlStr + '<li class="toc-item toc-item__h2"><a href="#' + idStr + '">' + title + '</a>';
      }
  
      if (tag === 'H3') {
        if (previousTag === 'H3') {
          htmlStr = htmlStr + '</li>';
        } else if (previousTag === 'H2') {
          htmlStr = htmlStr + '<ul class="toc-list toc-list__h3" >';
        } else if (previousTag === 'H4') {
          htmlStr = htmlStr + '</li></ul>';
        }
        htmlStr = htmlStr + '<li class="toc-item toc-item__h3"><a href="#' + idStr + '">' + title + '</a>';
      }
  
      if (tag === 'H4') {
        if (previousTag === 'H4') {
          htmlStr = htmlStr + '</li>';
        } else if (previousTag === 'H3') {
          htmlStr = htmlStr + '<ul class="toc-list toc-list__h4" >';
        }
        htmlStr = htmlStr + '<li class="toc-item toc-item__h4"><a href="#' + idStr + '">' + title + '</a>';
      }
  
      previousTag = tag;
    });
  
    $('#toc-list').append(htmlStr);
  
    /* setup style and scroll in toc for desktop */
    if ($(window).width() > 960) {
      // set show and hide toc button
      var tocJQ = $('.sub-nav');
      var btnShowHideJQ = $('#btn-show-hde-toc');

      btnShowHideJQ.click(function () {
        tocJQ.toggleClass('collapsed');
        $('.section__column--right').toggleClass('expanded');

        if ($(document).scrollTop() + $(window).height() >= $('.footer').offset().top) {
          $('#toc-list').css('max-height', $(window).height() - $('.footer').height() - 100);
        } else {
          $('#toc-list').css('max-height', $(window).height() - 100); 
        }

        if(tocJQ.hasClass('collapsed')) {
          $('#toc-list').css('overflow-y', 'hidden');
        } else {
          $('#toc-list').css('overflow-y', 'auto');
        }

        /* Scroll sidebar when scrollong main contents */
        // get the curremt top visible element in the main content
        var topContentViewportElsArray = $.grep($('.section__column h2, .section__column h3, .section__column h4'), function (item) {
          return $(item).offset().top + $(item).height() >= $(document).scrollTop();
        });
        var topContentViewportEl = topContentViewportElsArray[0];
        var currentTocLinkJQ = $('.sub-nav a[href="#' + $(topContentViewportEl).attr('id') + '"]');
  
        // set the link to the el above to be active
        $('.sub-nav a').removeClass('current');
        currentTocLinkJQ.addClass('current');
      });
  
      $(document).scroll(function () {
        /* dynamic styles */
        // fix the position of the toc when scrolling to main content
        if ($(document).scrollTop() >= $('#page-title--long-doc').offset().top) {
          $('.sub-nav').css('height', '0');
          $('#toc-main-heading').css('position', 'fixed');
          $('#toc-main-heading').css('top', '10px');
          $('#toc-list').css('position', 'fixed');
          $('#toc-list').css('top', '78px');
        } else {
          $('.sub-nav').css('height', 'auto');
          $('#toc-main-heading').css('position', 'static');
          $('#toc-list').css('position', 'static');
        }
  
        // fix the position of the toc when the footer is visible
        if ($(document).scrollTop() + $(window).height() >= $('.footer').offset().top) {
          $('#toc-list').css('max-height', $(window).height() - $('.footer').height() - 100);
          $('#toc-list').css('overflow-y', 'auto');
        } else {
          $('#toc-list').css('max-height', $(window).height() - 100);
          $('#toc-list').css('overflow-y', 'auto');
        }
  
        /* Scroll sidebar when scrollong main contents */
        // get the curremt top visible element in the main content
        var topContentViewportElsArray = $.grep($('.section__column h2, .section__column h3, .section__column h4'), function (item) {
          return $(item).offset().top + $(item).height() >= $(document).scrollTop();
        });
        var topContentViewportEl = topContentViewportElsArray[0];
        var currentTocLinkJQ = $('.sub-nav a[href="#' + $(topContentViewportEl).attr('id') + '"]');
  
        // set the link to the el above to be active
        $('.sub-nav a').removeClass('current');
        currentTocLinkJQ.addClass('current');
  
        // detect if the current top el in o-content is also visible in sidebar
        var tocListJQ = $('.toc-list');
  
        var currentLinkLiTop = currentTocLinkJQ.parent().offset().top;
        var tocListTop = tocListJQ.offset().top;
        var currentLinkLiBottom = currentLinkLiTop + currentTocLinkJQ.parent().height();
        var tocListBottom = tocListTop + tocListJQ.height();
  
        // scroll to the link in the sidebar if it is not visible
        if (currentLinkLiTop < tocListTop) {
          tocListJQ.stop().animate({
            scrollTop: tocListJQ.scrollTop() - (tocListTop - currentLinkLiTop)
          }, 1000, 'swing');
        }
        if (currentLinkLiBottom > tocListBottom) {
          tocListJQ.stop().animate({
            scrollTop: tocListJQ.scrollTop() + tocListJQ.height() + (currentLinkLiBottom - tocListBottom)
          }, 1000, 'swing');
        }
      });
    }
  }

}(jQuery));